/** An unverified link reference, independent of browser and member identity. */
export function validateReferralCode(value: unknown): string {
  if (typeof value !== 'string' || !/^[A-Za-z0-9_-]{1,32}$/.test(value)) {
    throw new Error('Invalid link code. Use 1–32 letters, digits, underscores or hyphens.');
  }
  return value;
}

export function referralFromSearch(search: string): string | null {
  const values = new URLSearchParams(search).getAll('ref');
  if (values.length === 0) return null;
  if (values.length !== 1) throw new Error('The link must contain only one reference code.');
  return validateReferralCode(values[0]);
}

export function conversationReferral(search: string, restoredCode?: unknown): string | null {
  const incoming = referralFromSearch(search);
  if (incoming !== null) return incoming;
  return restoredCode === undefined || restoredCode === null
    ? null
    : validateReferralCode(restoredCode);
}

export function validateWebsiteVisitId(value: unknown): string {
  if (typeof value !== 'string' || !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/.test(value)) {
    throw new Error('Invalid website visit reference.');
  }
  return value;
}

/** Visit attribution belongs to this arrival, never the restored conversation. */
export function websiteVisitFromSearch(search: string): string | null {
  const values = new URLSearchParams(search).getAll('website_visit_id');
  if (values.length === 0) return null;
  if (values.length !== 1) throw new Error('The link must contain only one website visit.');
  return validateWebsiteVisitId(values[0]);
}
